
import { motion } from "framer-motion";
import { useState, useEffect } from "react";

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: "Carlos Martínez",
      company: "TechStart Solutions",
      role: "CEO",
      text: "SEOgenia transformó completamente nuestra visibilidad online. En 3 meses pasamos de página 5 a top 3 en Google para nuestras keywords principales. El ROI ha sido espectacular.",
      rating: 5,
      image: "https://public.readdy.ai/ai/img_res/77423ca8f473bb1075e535c4f9f78ca2.jpg"
    },
    {
      name: "Laura Sánchez",
      company: "Boutique Elegance",
      role: "Directora Marketing",
      text: "Increíble trabajo con nuestro e-commerce. Las ventas orgánicas aumentaron un 180% en 6 meses. Su enfoque técnico y estratégico es exactamente lo que necesitábamos.",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=professional%20business%20woman%20marketing%20director%20smiling%20confident%20portrait%20clean%20simple%20background%20corporate%20headshot&width=100&height=100&seq=testimonial-2&orientation=squarish"
    },
    {
      name: "Miguel Ángel Torres",
      company: "Clínica Dental Sonrisa",
      role: "Director",
      text: "Gracias a su optimización local, ahora aparecemos primeros en 'dentista cerca de mí'. Las llamadas de nuevos pacientes se triplicaron. Inversión totalmente recuperada.",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=professional%20healthcare%20director%20man%20smiling%20confident%20portrait%20clean%20simple%20background%20medical%20professional%20headshot&width=100&height=100&seq=testimonial-3&orientation=squarish"
    },
    {
      name: "Ana Rodríguez",
      company: "Bufete Legal AR",
      role: "Socia Fundadora",
      text: "Su expertise en SEO para servicios profesionales es impresionante. Ahora dominamos las búsquedas de abogados en nuestra ciudad. Clientes de mucha mayor calidad.",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=professional%20lawyer%20woman%20partner%20smiling%20confident%20portrait%20clean%20simple%20background%20legal%20professional%20headshot&width=100&height=100&seq=testimonial-4&orientation=squarish"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-900 via-gray-900 to-slate-900">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            Resultados reales de empresas que confiaron en nosotros
          </p>
        </motion.div>

        <div className="relative max-w-4xl mx-auto">
          <div className="overflow-hidden">
            <motion.div
              key={currentIndex}
              initial={{ opacity: 0, x: 100 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -100 }}
              transition={{ duration: 0.5 }}
              className="bg-white/10 backdrop-blur-sm p-8 sm:p-12 rounded-2xl border border-white/20"
            >
              <div className="flex items-start gap-6 mb-6">
                <img
                  src={testimonials[currentIndex].image}
                  alt={testimonials[currentIndex].name}
                  className="w-16 h-16 rounded-full object-cover flex-shrink-0"
                />
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                    ))}
                  </div>
                  <p className="text-lg sm:text-xl text-white leading-relaxed mb-6 italic">
                    "{testimonials[currentIndex].text}"
                  </p>
                  <div>
                    <p className="font-bold text-white text-lg">
                      {testimonials[currentIndex].name}
                    </p>
                    <p className="text-gray-300">
                      {testimonials[currentIndex].role} en {testimonials[currentIndex].company}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Navigation Dots */}
          <div className="flex justify-center gap-3 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex
                    ? "bg-cyan-500 w-8"
                    : "bg-white/30 hover:bg-white/50"
                }`}
                aria-label={`Ir al testimonio ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
